import { loginResponse } from "../models/auth/loginResponse";
import { registerUser } from "../store/onboarding/Onboarding";
import CryptoJS from "crypto-js";

class AuthService {
  private static LOCK_KEY = "aYWqA3J6Q6";
  static getLoginVerificationError(message: string): LoginVerificationErrors {
    if (
      Object.values(LoginVerificationErrors).includes(
        message as LoginVerificationErrors
      )
    ) {
      return message as LoginVerificationErrors;
    }
    return LoginVerificationErrors.None;
  }

  static saveUser(data: loginResponse) {
    localStorage.setItem("token", data.tokenClass.token);
    localStorage.setItem("user", JSON.stringify(data));
  }

  static logOut() {
    localStorage.clear();
  }

  static updateUserProfileImage(imageUrl: string) {
    const user = AuthService.user;
    if (user) {
      user.data.profilePictureUrl = imageUrl;
      AuthService.saveUser(user);
    }
  }

  static get user(): loginResponse | null {
    return JSON.parse(localStorage.getItem("user") || "null");
  }

  static decryptUserData(encryptedData: string): registerUser | undefined {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, AuthService.LOCK_KEY);

      const originalData = bytes.toString(CryptoJS.enc.Utf8);

      if (originalData === null || originalData === "") return undefined;

      return JSON.parse(originalData);
    } catch (error) {
      console.log("Error parsing JSON", error);
      return undefined;
    }
  }

  static encryptUserData(data: string): string {
    const encryptedData = CryptoJS.AES.encrypt(
      data,
      AuthService.LOCK_KEY
    ).toString();
    sessionStorage.setItem("registerUser", encryptedData);
    return encryptedData;
  }
}

export enum LoginVerificationErrors {
  UnverifiedPhoneNumber = "Please verify your PhoneNumber",
  UnverifiedEmail = "Please verify your Email",
  None = "None",
}

export default AuthService;
